import { getEncodedCurrentPath, getPmsCallbackUrlFromSearch } from '@/lib/pms-callback';
import { tokenStorage } from '@/lib/token-storage';
import { redirect, replace } from 'react-router';

export function requirePMSAuthLoader(): Response | null {
  if (!tokenStorage.hasToken()) {
    const encodedCallback = getEncodedCurrentPath();
    const redirectUrl = `/login/pms${encodedCallback ? `?callbackUrl=${encodedCallback}` : ''}`;

    return redirect(redirectUrl);
  }

  return null;
}

export function loginPMSPageLoader(): Response | null {
  const callbackUrl = getPmsCallbackUrlFromSearch();

  if (tokenStorage.hasToken()) {
    const redirectUrl = callbackUrl ?? '/';
    return redirect(redirectUrl);
  }

  return null;
}

/**
 * 매칭되지 않은 경로 진입 시 인증 상태에 따라 분기 리다이렉트한다.
 * 잘못된 URL이 히스토리에 남지 않도록 replace로 처리한다.
 */
export function notFoundRedirectLoader(): Response {
  if (tokenStorage.hasToken()) {
    return replace('/mangrover/manage');
  }
  return replace('/login/pms');
}
